export const errorKey = {
    SEK: 'LessAmount',
    EUR: 'LessAmountEUR',
    USD: 'LessAmountUSD',
    GBP: 'LessAmountGBP',
    CHF: 'LessAmountCHF',
    CAD: 'LessAmountCAD',
    AUD: 'LessAmountAUS',
    NOK: 'LessAmountNOK',
    DKK: 'LessAmountDKK',
    JPY: 'LessAmountJPY',
    CNY: 'LessAmountCNY',
};